import React, { useEffect, useState } from 'react'
import { getStocksWithPage } from "../../services/serviceStock";
import { Button, Card, message, Row, Table, Upload } from "antd";
import StockActions from "./StockActions";
import StockCreate from "./StockCreate";
import { SearchOutlined, UploadOutlined } from "@ant-design/icons";
import config from "../../config";
import cookieOps from "../../services/cookieOps";
import ERROR_MESSAGE from "../../errorMessages";
import StockHandleWarehouse from "./StockHandleWarehouse";
import Filter from "../filterWrapper/Filter";
import StockFilters from "./StockFilters";
import { useLocation } from "@reach/router";

const Stock = ({ navigate }) => {
    const location = useLocation();
    const [sortedList, setSortedList] = useState([])
    const [newModal, setNewModal] = useState(false)
    const [openFilter, setOpenFilter] = useState(false)
    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 10,
        total: 0
    });
    const [filters, setFilters] = useState({
        stockName: '',
        stockCode: '',
        brand: ''
    });

    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const page = parseInt(queryParams.get('pn')) || 1;
        const pageSize = parseInt(queryParams.get('ps')) || 10;

        getStockData(page, pageSize);
    }, [location.search]);

    const getStockData = (page, pageSize, requestObj = filters) => {
        const mockFilters = { ...requestObj };
        mockFilters.pageSize = pageSize;
        mockFilters.pageNo = Number(page) - 1;

        getStocksWithPage(mockFilters)
            .then(({ data }) => {
                handlers.sortData(data.content)
                setPagination({
                    ...pagination,
                    current: page,
                    total: data.totalElements,
                    pageSize: pageSize
                })
            })
    };

    const handlers = {
        updater() {
            getStockData(1, 10);
        },
        modalCloser() {
            setNewModal(!newModal)
        },
        sortData(list) {
            const sorted = list.map(stock => (
                {
                    key: stock.id,
                    id: stock.id,
                    stockName: stock.n,
                    stockCode: stock.c,
                    stockDescription: stock.d,
                    stockPrice: stock.p,
                    stockUnit: stock.u,
                    stockCurrency: stock.cr,
                    stockQuantity: stock.q,
                    stockFirmCode: stock.fsC,
                    stockBrand: stock.bn,
                    brand: stock.bn
                }
            ))
            setSortedList(sorted)
        }
    }
    const toggleFilterDisplay = () => setOpenFilter(!openFilter)
    const excelUpload = ({ file }) => {

        if (file.status === 'done') {
            message.success('İşlem Başarılı')
            resetFilters();
        } else if (file.status === 'error') {
            let errors = ERROR_MESSAGE["TR"]
            message.error(errors[file.response.message])
        }
    }
    function handleFilter({ stockName, stockCode, brand }) {
        const requestObj = {}
        Object.keys(arguments[0]).map(key => requestObj[key] = arguments[0][key])
        setFilters(requestObj)
        navigate(`?ps=${10}&pn=${1}&rn=${Math.floor(Math.random(1) * 1000)}`);

        return new Promise((resolve => resolve(200)))
    };

    const resetFilters = () => {
        const baseObj = {
            stockName: '',
            stockCode: '',
            brand: ''
        };
        setFilters(baseObj);
        navigate(`?ps=${10}&pn=${1}&rn=${Math.floor(Math.random(1) * 1000)}`);
    };

    const columns = [
        {
            title: 'Stok Adı',
            dataIndex: 'stockName',
            key: 'stockName'
        },
        {
            title: 'Kodu',
            dataIndex: 'stockCode',
            key: 'stockNameCode'
        },
        {
            title: 'Açıklama',
            dataIndex: 'stockDescription',
            key: 'stockDescription'
        },
        {
            title: 'Firma Kodu',
            dataIndex: 'stockFirmCode',
            key: 'stockFirmCode'
        },
        {
            title: 'Marka',
            dataIndex: 'stockBrand',
            key: 'stockBrand'
        },
        {
            title: 'Adet',
            dataIndex: 'stockQuantity',
            key: 'stockQuantity'
        },
        {
            title: 'Birim',
            dataIndex: 'stockUnit',
            key: 'stockUnit'
        },
        {
            title: 'Fiyat',
            dataIndex: 'stockPrice',
            key: 'stockPrice',
            render: (t) => new Intl.NumberFormat().format(t)
        },
        {
            title: 'Para Birimi',
            dataIndex: 'stockCurrency',
            key: 'stockCurrency'
        },
        {
            title: 'Depo',
            dataIndex: 'stockWarehouseCode',
            key: 'stockWarehouseCode',
            render: (t, r) => <StockHandleWarehouse stockId={r.id} />
        },
        {
            title: 'İşlemler',
            key: 'action',
            render: (text, record) => <StockActions record={record} updater={handlers.updater} />
        }
    ]

    const handlePaginationChange = (pageNumber, pageSize) => {
        navigate(`?ps=${pageSize}&pn=${pageNumber}`);
    };

    return (
        <React.Fragment>
            <Card title={'Stok Listesi'}
                extra={
                    [
                        <div key={'ButtonGroupDiv'}>
                            <Button key={'CreateButton'} onClick={() => setNewModal(!newModal)} type={'primary'}> Yeni
                                Ekle </Button>
                            <Upload
                                key={'UploadButton'}
                                accept={'.xls, .xlsx'}
                                action={`${config.baseURL}/stock/import-stocks`}
                                headers={{
                                    'Authorization': cookieOps.readCookie('mySweetApple'),
                                    'tenantId': window.localStorage.getItem('tenant')
                                }}
                                onChange={excelUpload}
                            >
                                <Button key={'PrintButton'}>
                                    <UploadOutlined /> Toplu Aktarım
                                </Button>
                            </Upload>
                        </div>
                    ]
                }
            >
                <Row justify={"start"}>
                    <div className={'filter-row-container'} onClick={toggleFilterDisplay}><SearchOutlined /></div>
                </Row>
                <Table
                    scroll={{ x: 'max-content' }}
                    columns={columns}
                    dataSource={sortedList}
                    pagination={{
                        ...pagination,
                        showSizeChanger: true,
                        showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
                        onChange: handlePaginationChange,
                    }}
                />
            </Card>

            {
                newModal
                    ? <StockCreate show={newModal} modalCloser={handlers.modalCloser} updater={handlers.updater} />
                    : null
            }
            {
                <Filter
                    showDrawer={openFilter}
                    closer={toggleFilterDisplay}
                    relatedComponent={'Stok'}
                    handler={handleFilter}
                    resetHandler={resetFilters}
                >
                    <StockFilters />
                </Filter>
            }

        </React.Fragment>
    )
}
export default Stock

